import React,{useEffect} from 'react';
import {Link} from 'react-router-dom';
import {applyRouteSeo} from '../helpers/seoHelper';

export const img=(id,w=1600)=>`https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=86`;
export const Back=()=> <Link className="demo-return" to="/demos">← All demos</Link>;
export const DemoSeo=({path})=>{useEffect(()=>applyRouteSeo(path),[path]);return null;};
export const DemoNotice=({pages='One-page concept'})=><span style={{fontSize:11,fontWeight:850,letterSpacing:'.12em',textTransform:'uppercase',opacity:.62}}>{pages} · Demo by DevCraft</span>;
